import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "counter" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "counter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_easy_login_form = _resolveComponent("easy-login-form")!

  return (!_ctx.isEstateAgencyMode)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.isDetail)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.like && _ctx.like(...args))),
              class: _normalizeClass(["button button--like", { 'is-active': _ctx.ad.isLike, 'has-likes': _ctx.ad.likeCount > 0 }]),
              title: _ctx.$t('AdListItemLike.button-like-title')
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.ad.likeCount), 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('AdListItemLike.button-like')), 1)
            ], 10, _hoisted_1))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.like && _ctx.like(...args)), ["stop","prevent"])),
              class: _normalizeClass(["estate-card__like", { 'is-active': _ctx.ad.isLike, 'has-likes': _ctx.ad.likeCount > 0 }]),
              title: _ctx.$t('AdListItemLike.button-like-title')
            }, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.ad.likeCount), 1)
            ], 10, _hoisted_4)),
        (_ctx.isLoginModalVisible)
          ? (_openBlock(), _createBlock(_Teleport, {
              key: 2,
              to: "#container"
            }, [
              _createVNode(_component_easy_login_form, {
                onClose: _ctx.closeLoginModal,
                showCloseButton: true,
                alertText: _ctx.$t('like-not-logged-in')
              }, null, 8, ["onClose", "alertText"])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}